import React from 'react'
import { useTranslation } from 'react-i18next'

const CategoryNav = ({ 
  categories = [], 
  activeCategory = 'all', 
  onCategoryChange,
  className = ""
}) => {
  const { t } = useTranslation()

  // 获取分类名称的翻译
  const getCategoryName = (categoryId) => {
    const key = `products.categories.${categoryId}`
    const translated = t(key)
    // 如果翻译键不存在，返回原始名称
    return translated === key ? (categories.find(cat => cat.id === categoryId)?.name || categoryId) : translated
  }

  return (
    <div className={`category-nav ${className}`}>
      <div className="category-grid flex flex-wrap gap-1">
        {/* 全部分类 */}
        <button
          onClick={() => onCategoryChange('all')}
          className={`category-card px-4 py-3 text-center rounded-lg border-2 transition-all duration-200 min-w-[80px]
                     ${activeCategory === 'all'
                       ? 'border-primary-500 bg-primary-50 text-primary-700'
                       : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'}`}
        >
          <div className="category-name text-xs font-medium">
            {t('products.categories.all')}
          </div>
        </button>

        {/* 具体分类 */}
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`category-card px-4 py-3 text-center rounded-lg border-2 transition-all duration-200 min-w-[80px]
                       ${activeCategory === category.id
                         ? 'border-primary-500 bg-primary-50 text-primary-700'
                         : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'}`}
          >
            <div className="category-name text-xs font-medium">
              {getCategoryName(category.id)}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default CategoryNav 